<template>
  <div class="title">
    <h2>{{titleText}}</h2>
    <div class="line"></div>
  </div>
</template>

<script>
export default {
  name: "CommonTitle",
  props: {
    titleText: String
  }
}
</script>

<style scoped lang="scss">
.title{
  margin-bottom: 20px;
  h2 {
    line-height: 60px;
    font-size: $font-size-md;
    font-weight: 700;
  }

}
</style>
